import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'

import Button from 'components/Button'

import { driverListChanged, fetchDrivers } from './actions'

import DriverList from './DriverList'
import AddDriver from './AddDriver'

import './styles.scss'

export class Drivers extends BaseComponent {

  constructor(props) {
    super(props)

    this._bind('_openAddDriversModal')
  }

  componentDidMount() {
    const params = this.props.match.params
    this.props.fetchDrivers(params.id, params.vehicleId)
  }

  _openAddDriversModal() {
    this.context.toggleModal(
      true,
      <AddDriver
        userId={this.props.match.params.id}
        vehicleId={this.props.match.params.vehicleId}
      />
    )
  }

  render() {

    return (
      <div>
        <div id="addDriver" className="d-flex justify-content-end">
          <Button onClick={this._openAddDriversModal} icon="person_add" size="small">
            <span className="material-icons">person_add</span>
            Agregar nuevo conductor
          </Button>
        </div>
        <DriverList params={this.props.match.params} drivers={this.props.drivers}/>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    drivers: state.driversVehicleDetail.get('drivers')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    driverListChanged: (drivers) => dispatch(driverListChanged(drivers)),
    fetchDrivers: (userId, vehicleId) => dispatch(fetchDrivers(userId, vehicleId))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Drivers)


Drivers.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Drivers/index.js